import React from 'react';
import { Edit3, X } from 'lucide-react';
import { SmallText } from '../../../components/brand/BrandTypography';
import { IconButton, PrimaryButton, TertiaryButton } from '../../../components/brand/BrandButton';

const TriggersTab = ({ triggers, editingTrigger, setEditingTrigger, onSave }) => {
    return (
        <div className="space-y-4">
            <div className="mb-4 p-4 bg-[#7D8E95]/20 rounded-xl border border-[#7D8E95]/20">
                <SmallText className="text-[#7D8E95]">
                    <strong>ADHD Relational Triggers</strong> - Click on any trigger to edit it. Help users recognize ADHD-specific patterns that influence conflict.
                </SmallText>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {triggers.map(trigger => (
                    <div 
                        key={trigger.trigger_id} 
                        className="bg-white rounded-xl border border-[#FFBB98] p-4 cursor-pointer hover:border-[#7D8E95]/50 transition-colors"
                        onClick={() => setEditingTrigger({...trigger})}
                    >
                        <div className="flex items-center gap-2 mb-3">
                            <span className="px-2 py-1 text-xs font-medium rounded-full bg-[#7D8E95]/30 text-[#7D8E95]">
                                {trigger.short_name}
                            </span>
                            <h4 className="font-medium text-[#1D6B6B] flex-1">{trigger.name}</h4>
                            <Edit3 className="w-4 h-4 text-[#7D8E95]" />
                        </div>
                        <p className="text-sm text-[#7D8E95] mb-3">{trigger.description}</p>
                        <div className="pt-2 border-t border-[#FFBB98]">
                            <span className="text-xs text-[#7D8E95] font-medium">Insight:</span>
                            <p className="text-xs text-[#7D8E95] mt-1">{trigger.insight}</p>
                        </div>
                    </div>
                ))}
            </div>
            
            {editingTrigger && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto p-6">
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="text-lg font-medium">Edit ADHD Trigger</h3>
                            <IconButton onClick={() => setEditingTrigger(null)}>
                                <X className="w-5 h-5" />
                            </IconButton>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Name</label>
                                <input 
                                    value={editingTrigger.name} 
                                    onChange={(e) => setEditingTrigger({...editingTrigger, name: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Short Name</label>
                                <input 
                                    value={editingTrigger.short_name} 
                                    onChange={(e) => setEditingTrigger({...editingTrigger, short_name: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Description</label>
                                <textarea 
                                    value={editingTrigger.description} 
                                    onChange={(e) => setEditingTrigger({...editingTrigger, description: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={3}
                                />
                            </div>
                            <div>
                                <label className="text-sm text-[#7D8E95] mb-1 block">Insight</label>
                                <textarea 
                                    value={editingTrigger.insight} 
                                    onChange={(e) => setEditingTrigger({...editingTrigger, insight: e.target.value})}
                                    className="w-full p-3 border border-[#FFBB98] rounded-xl"
                                    rows={3}
                                />
                            </div>
                        </div>
                        <div className="flex gap-3 mt-6">
                            <TertiaryButton onClick={() => setEditingTrigger(null)} className="flex-1">Cancel</TertiaryButton>
                            <PrimaryButton onClick={() => onSave(editingTrigger)} className="flex-1">Save</PrimaryButton>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TriggersTab;
